var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "add_svg__svg-icon",
    style: {
      width: "1.0712890625em",
      height: "1em",
      verticalAlign: "middle"
    },
    viewBox: "0 0 1097 1024",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    overflow: "hidden"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M789.702 441.122H570.807V228.114a29.893 29.893 0 00-59.775 0v218.895H298.025a30.265 30.265 0 00-35.28 23.995 35.727 35.727 0 00-.468 5.727 28.136 28.136 0 0026.38 29.882h216.34v213.008a29.882 29.882 0 0059.764 0V506.613h213.007a28.147 28.147 0 0029.883-26.369v-3.332c-.16-17.81-.16-35.77-17.96-35.77zM540.925 0C277.521 0 64.002 213.487 64.002 476.923S277.49 953.846 540.925 953.846s476.923-213.487 476.923-476.923C1017.049 213.838 804.042.83 540.925 0zm0 888.28c-227.166 0-411.25-184.233-411.25-411.39S313.748 65.652 540.915 65.652s411.388 184.073 411.388 411.24c-.48 226.996-184.403 410.92-411.389 411.388zm0 0"
  })));
}

export default SvgAdd;